"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _excluded = ["handleSubmit", "valid", "onReset"];

function CancelForm(_ref) {
  var handleSubmit = _ref.handleSubmit,
      valid = _ref.valid,
      onReset = _ref.onReset,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var handleReset = function handleReset() {
      onReset();
    };

    return /*#__PURE__*/_react["default"].createElement("form", {
      "data-locator": props['data-locator'] + '.cancel.form',
      className: _defaultModule["default"]['form'],
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement("article", {
      className: _defaultModule["default"]['content'],
      "data-locator": props['data-locator'] + '.cancel.form.content'
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _defaultModule["default"]["description"]
    }, "\u041E\u0442\u043C\u0435\u043D\u0430 \u0445\u043E\u043B\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"), /*#__PURE__*/_react["default"].createElement(_storybook.TextareaField, {
      "data-locator": props['data-locator'] + '.cancel.form.reason',
      label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435",
      name: "reason"
    })), /*#__PURE__*/_react["default"].createElement("footer", {
      className: _defaultModule["default"]['controls']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": props['data-locator'] + 'cancel.form.submit',
      type: "submit",
      mode: "success",
      className: _defaultModule["default"]['button'],
      disabled: !valid
    }, "\u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C"), /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": props['data-locator'] + 'cancel.form.withdraw',
      className: _defaultModule["default"]['button'],
      form: "context",
      onClick: handleReset
    }, "\u041D\u0435\u0442")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = CancelForm;
exports["default"] = _default;